// Static subset of common ISO-4217 codes. Replace with backend-driven /currencies once available.
export const CURRENCIES = ['USD', 'EUR', 'GBP', 'CNY', 'RUB', 'TRY', 'AED', 'KZT', 'INR', 'JPY'];
export const DEFAULT_CURRENCY = 'USD';
